import figma from '../../assets/image/stack/figma-tech-icon.svg';
import html from '../../assets/image/stack/html-tech-icon.svg';
import css from '../../assets/image/stack/css-tech-icon.svg';
import bootstrap from '../../assets/image/stack/bootstrap-tech-icon.webp';
import angularjs from '../../assets/image/stack/angularjs-tech-icon.webp';
import react from '../../assets/image/stack/react-js-tech-icon.svg';
import tailwind from '../../assets/image/stack/tailwind-css-tech-icon.webp';
import materialui from '../../assets/image/stack/material-ui-tech-icon.webp';
import nextjs from '../../assets/image/stack/next-js-tech-icon.webp';

const StackImage = { figma, html, css, bootstrap , angularjs , react ,tailwind , materialui ,  nextjs};

export default StackImage;
